// extracted by mini-css-extract-plugin
export default {"container":"tournamentAccess_container__FKfWX","allAdminsWrapper":"tournamentAccess_allAdminsWrapper__BJEfq","loaderContainer":"tournamentAccess_loaderContainer__gQNBB"};